import { userManagementConstant } from "../_constants/userManagement.constant";
import { APIcallFunction, APIcallFunctionMedia, headerForPrivateAPI, headerForPrivateMediaAPI } from "../_helpers";
import { alertActions } from "./alert.actions";

export const userManagementActions = {
  getUserManagementList,
  updateUserManagement,
  getCountryCodeList,
  getUserManagementListPromise,
  userBankDetailsList,
  raisedRequestList,
  raisedRequestUpdateStatus,
  updateUserBankDetailsStatus,
  uploadImageAPI,
  getUserDetails,
  viewMerchantKycDetails,
  swappingList,
  getLoginHistory,
  getUserBankDetails,
  getTransactionListByUserId,
  buyPkrdHistory,
  orderHistory,
  getWebStoreList, userStatusUpdateBlockActiveInActive, getMerchantApiKeyListAdmin, getMerchantWebStoreChargeList, updateMerchantWebStoreCharge,
  raisedRequestListExpress, buyPkrdHistoryExpressCheckout, updateTransactionLimit,
  raisedRequestMerchantUpdateStatus,
  updateMerchantBankDetailsStatus

};

function getUserManagementList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/user/getUserList'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) { return { type: userManagementConstant.GET_USER_LIST_REQUEST, user } }
  function success(user) { return { type: userManagementConstant.GET_USER_LIST_SUCCESS, user } }
  function failure(error) { return { type: userManagementConstant.GET_USER_LIST_FAILURE, error } }
}






function getUserDetails(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/user/getUserDetails'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) { return { type: userManagementConstant.GET_USER_DETAILS_BY_ID_REQUEST, user } }
  function success(user) { return { type: userManagementConstant.GET_USER_DETAILS_BY_ID_SUCCESS, user } }
  function failure(error) { return { type: userManagementConstant.GET_USER_DETAILS_BY_ID_FAILURE, error } }
}





function viewMerchantKycDetails(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/merchantKyc/viewMerchantKycDetails'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));

      }
    );
  };
  function request(user) { return { type: userManagementConstant.GET_MERCHANT_KYC_DETAILS_BY_ID_REQUEST, user } }
  function success(user) { return { type: userManagementConstant.GET_MERCHANT_KYC_DETAILS_BY_ID_SUCCESS, user } }
  function failure(error) { return { type: userManagementConstant.GET_MERCHANT_KYC_DETAILS_BY_ID_FAILURE, error } }
}





function getMerchantWebStoreChargeList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/webStore/getMerchantWebStoreChargeList'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));

      }
    );
  };
  function request(user) { return { type: userManagementConstant.GET_MERCHANT_WEB_STOR_CHARGE_LIST_REQUEST, user } }
  function success(user) { return { type: userManagementConstant.GET_MERCHANT_WEB_STOR_CHARGE_LIST_SUCCESS, user } }
  function failure(error) { return { type: userManagementConstant.GET_MERCHANT_WEB_STOR_CHARGE_LIST_FAILURE, error } }
}






















function orderHistory(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/order/orderHistory'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));

      }
    );
  };
  function request(user) { return { type: userManagementConstant.GET_ORDER_HISTORY_LIST_REQUEST, user } }
  function success(user) { return { type: userManagementConstant.GET_ORDER_HISTORY_LIST_SUCCESS, user } }
  function failure(error) { return { type: userManagementConstant.GET_ORDER_HISTORY_LIST_FAILURE, error } }
}




function swappingList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/swap/swappingList'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) { return { type: userManagementConstant.GET_SWAP_LIST_REQUEST, user } }
  function success(user) { return { type: userManagementConstant.GET_SWAP_LIST_SUCCESS, user } }
  function failure(error) { return { type: userManagementConstant.GET_SWAP_LIST_FAILURE, error } }
}








///buyPkrdHistory

function buyPkrdHistory(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/express/buyPkrdHistory'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) { return { type: userManagementConstant.GET_BUY_PKRD_HISTORY_LIST_REQUEST, user } }
  function success(user) { return { type: userManagementConstant.GET_BUY_PKRD_HISTORY_LIST_SUCCESS, user } }
  function failure(error) { return { type: userManagementConstant.GET_BUY_PKRD_HISTORY_LIST_FAILURE, error } }
}




function buyPkrdHistoryExpressCheckout(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/express/buyPkrdHistory'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) { return { type: userManagementConstant.GET_BUY_PKRD_EXPRESS_CHECKOUT_HISTORY_LIST_REQUEST, user } }
  function success(user) { return { type: userManagementConstant.GET_BUY_PKRD_EXPRESS_CHECKOUT_HISTORY_LIST_SUCCESS, user } }
  function failure(error) { return { type: userManagementConstant.GET_BUY_PKRD_EXPRESS_CHECKOUT_HISTORY_LIST_FAILURE, error } }
}








function getWebStoreList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/webStore/getWebStoreList'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) { return { type: userManagementConstant.GET_WEB_STORE_LIST_REQUEST, user } }
  function success(user) { return { type: userManagementConstant.GET_WEB_STORE_LIST_SUCCESS, user } }
  function failure(error) { return { type: userManagementConstant.GET_WEB_STORE_LIST_FAILURE, error } }
}




function getLoginHistory(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/admin/getLoginHistory'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) { return { type: userManagementConstant.GET_LOGIN_HISTORY_LIST_REQUEST, user } }
  function success(user) { return { type: userManagementConstant.GET_LOGIN_HISTORY_LIST_SUCCESS, user } }
  function failure(error) { return { type: userManagementConstant.GET_LOGIN_HISTORY_LIST_FAILURE, error } }
}











//export data
function getUserManagementListPromise(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/user/getUserList'
  };
  return APIcallFunction(credentials);

}

//update Status
function updateUserManagement(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/user/userStatusUpdateBlockActiveInActive",
  };
  return APIcallFunction(credentials)
}

/// update updateMerchantWebStoreCharge 

function updateMerchantWebStoreCharge(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/webStore/updateMerchantWebStoreCharge ",
  };
  return APIcallFunction(credentials)
}




/// update user status
function userStatusUpdateBlockActiveInActive(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/user/userStatusUpdateBlockActiveInActive",
  };
  return APIcallFunction(credentials)
}


//get CountryCodeList
function getCountryCodeList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: "/user/getAllCountryCodeListApi",
  };
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) {
    return {
      type: userManagementConstant.GET_COUNTRY_CODE_LIST_REQUEST,
      user,
    };
  }
  function success(user) {
    return {
      type: userManagementConstant.GET_COUNTRY_CODE_LIST_SUCCESS,
      user,
    };
  }
  function failure(error) {
    return {
      type: userManagementConstant.GET_COUNTRY_CODE_LIST_FAILURE,
      error,
    };
  }
}


function userBankDetailsList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/userBankDetails/userBankDetailsList'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) { return { type: userManagementConstant.GET_USER_BANK_DETAILS_LIST_REQUEST, user } }
  function success(user) { return { type: userManagementConstant.GET_USER_BANK_DETAILS_LIST_SUCCESS, user } }
  function failure(error) { return { type: userManagementConstant.GET_USER_BANK_DETAILS_LIST_FAILURE, error } }
}





/// GET MERCHANT API KEY LIST 


function getMerchantApiKeyListAdmin(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/merchantApiKey/getMerchantApiKeyListAdmin'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) { return { type: userManagementConstant.GET_MERCHANT_API_KEY_LIST_REQUEST, user } }
  function success(user) { return { type: userManagementConstant.GET_MERCHANT_API_KEY_LIST_SUCCESS, user } }
  function failure(error) { return { type: userManagementConstant.GET_MERCHANT_API_KEY_LIST_FAILURE, error } }
}









function getUserBankDetails(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/userBankDetails/getUserBankDetails'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) { return { type: userManagementConstant.GET_BANK_DETAILS_LIST_REQUEST, user } }
  function success(user) { return { type: userManagementConstant.GET_BANK_DETAILS_LIST_SUCCESS, user } }
  function failure(error) { return { type: userManagementConstant.GET_BANK_DETAILS_LIST_FAILURE, error } }
}





function updateUserBankDetailsStatus(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/userBankDetails/updateUserBankDetailsStatus'
  }
  return APIcallFunction(credentials)
}


function raisedRequestList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/redeemRequest/raisedRequestList'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) { return { type: userManagementConstant.GET_REDEEM_REQUEST_LIST_REQUEST, user } }
  function success(user) { return { type: userManagementConstant.GET_REDEEM_REQUEST_LIST_SUCCESS, user } }
  function failure(error) { return { type: userManagementConstant.GET_REDEEM_REQUEST_LIST_FAILURE, error } }
}



function raisedRequestListExpress(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/redeemRequest/raisedRequestList'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) { return { type: userManagementConstant.GET_REDEEM_REQUEST_LIST_EXPRESS_REQUEST, user } }
  function success(user) { return { type: userManagementConstant.GET_REDEEM_REQUEST_LIST_EXPRESS_SUCCESS, user } }
  function failure(error) { return { type: userManagementConstant.GET_REDEEM_REQUEST_LIST_EXPRESS_FAILURE, error } }
}





function getTransactionListByUserId(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/transaction/getTransactionListByUserId'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) { return { type: userManagementConstant.GET_TRANSACTION_LIST_BY_USERID_REQUEST, user } }
  function success(user) { return { type: userManagementConstant.GET_TRANSACTION_LIST_BY_USERID_SUCCESS, user } }
  function failure(error) { return { type: userManagementConstant.GET_TRANSACTION_LIST_BY_USERID_FAILURE, error } }
}


function raisedRequestUpdateStatus(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/redeemRequest/raisedRequestUpdateStatus'
  }
  return APIcallFunction(credentials)
}


async function uploadImageAPI(data) {
  const formData = new FormData();
  if (data) {
    formData.append('image', data);
  } else {
    alertActions.error('Please select an image.');
    return;
  }

  const credentials = {
    header: headerForPrivateMediaAPI(),
    method: "POST",
    body: formData,
    endPoint: '/user/uploadImage'
  };
  return await APIcallFunctionMedia(credentials);

  // try {
  //   const response = await APIcallFunctionMedia(credentials);
  //   return response.data;
  // } catch (error) {
  //   console.log('Error uploading image:', error); 
  // }
};







function updateTransactionLimit(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/user/updateTransactionLimit'
  }
  return APIcallFunction(credentials)
}

function raisedRequestMerchantUpdateStatus(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/redeemRequest/raisedRequestMerchantUpdateStatus'
  }
  return APIcallFunction(credentials)
}

function updateMerchantBankDetailsStatus(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/userBankDetails/updateMerchantBankDetailsStatus'
  }
  return APIcallFunction(credentials)
}